import { BaseService } from './BaseService';

export const EmpenhoSiafAlocacaoService = {
    /**
     * Listar elementos primários elegíveis para alocação
     * @param {Object} params - Parâmetros de filtro (ano)
     * @returns {Promise} Lista de elementos primários elegíveis
     */
    async listarElementosElegiveis(params = {}) {
        try {
            const queryParams = new URLSearchParams(params).toString();
            const url = `empenhos-siaf/alocacoes/elementos-elegiveis${queryParams ? '?' + queryParams : ''}`;
            return await BaseService.fetchResponseFromAPIGet(url);
        } catch (error) {
            console.error('Erro ao listar elementos primários elegíveis:', error);
            return {
                error: true,
                message: 'Erro ao carregar elementos primários elegíveis'
            };
        }
    },

    /**
     * Listar alocações de um empenho
     * @param {number} empenhoId - ID do empenho SIAF
     * @returns {Promise} Lista de alocações
     */
    async listarAlocacoes(empenhoId) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`empenhos-siaf/${empenhoId}/alocacoes`);
        } catch (error) {
            console.error('Erro ao listar alocações:', error);
            return {
                error: true,
                message: 'Erro ao carregar alocações'
            };
        }
    },

    /**
     * Criar nova alocação
     * @param {number} empenhoId - ID do empenho SIAF
     * @param {Object} dados - Dados da alocação
     * @returns {Promise} Resultado da operação
     */
    async criarAlocacao(empenhoId, dados) {
        try {
            // Converter para FormData
            const formData = new FormData();
            formData.append('elemento_primario_id', dados.elemento_primario_id);
            formData.append('elemento_primario_type', dados.elemento_primario_type);
            formData.append('valor', dados.valor);
            
            return await BaseService.fetchResponseFromAPIPost(`empenhos-siaf/${empenhoId}/alocacoes`, formData);
        } catch (error) {
            console.error('Erro ao criar alocação:', error);
            return {
                error: true,
                message: 'Erro ao criar alocação'
            };
        }
    },

    /**
     * Excluir alocação
     * @param {number} alocacaoId - ID da alocação
     * @returns {Promise} Resultado da operação
     */
    async excluirAlocacao(alocacaoId) {
        try {
            return await BaseService.fetchResponseFromAPIDelete(`empenhos-siaf/alocacoes/${alocacaoId}`);
        } catch (error) {
            console.error('Erro ao excluir alocação:', error);
            return {
                error: true,
                message: 'Erro ao excluir alocação'
            };
        }
    },

    /**
     * Obter resumo de alocações de um empenho
     * @param {number} empenhoId - ID do empenho SIAF
     * @returns {Promise} Resumo das alocações
     */
    async obterResumo(empenhoId) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`empenhos-siaf/${empenhoId}/alocacoes/resumo`);
        } catch (error) {
            console.error('Erro ao obter resumo de alocações:', error);
            return {
                error: true,
                message: 'Erro ao obter resumo de alocações'
            };
        }
    }
};

